import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  FormControl,
  FormLabel,
  CircularProgress,
  Snackbar,
  Link,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import welcomeimage from "../images/logo/welcome.jpg"; // Keep your logo import
import logo from "../images/logo/logo.png"; // Keep your logo import

const REACT_EXPRESS = process.env.REACT_APP_EXPRESS_SERVER;

// The base64 string you provided
const backgroundImage =
  "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBxITEBUQEhMVFhUVFxUYFRUVFRUVFhUVFxgXGBUXFhUYHSggGB0lHRgXITEhJSkrLi4uFyA1ODMsNygtLisBCgoKDg0OGhAQGy0lHiUtLS0tLS0tLS0tLS0tLSstLS0tKy0tLSstLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0rLf/AABEIAMgA/AMBIgACEQEDEQH/xAAcAAABBQEBAQAAAAAAAAAAAAADAAECBAUGBwj/xABJEAABAwIDBAYHBQUFBgcAAAABAAIRAyEEEjEFQVFhBhMicYGRBzKhscHR8BRCUmKSFSNTouFjcoLS8RYkM0NUkxclNHOjssL/xAAZAQADAQEBAAAAAAAAAAAAAAAAAQMCBAX/xAArEQACAgEEAgECBQUAAAAAAAAAAQIRAxIhMUEEUSIUYRNScaHBMoGRsdH/2gAMAwEAAhEDEQA/AEzGsO+41G9TOKbx4e369ixdp7LZMtzh82c175HmTbkB4LArbQfTeaL3AxFxEXgxHIx/RenPLKL3ORQTO+Y4HQ/WickLm8BtOWloucwzW3EjTxKqdIMa49YWSQAJgxreR3W8rb5086UbM6LdHYQlC43YPSWG9VUMmB1ZNzMXafmp4bbdR7yAbNAgbiRGvKbTzWV5cHVcj/CZ09bEhr2t/FPsU21hv+tPn7Fz20sa2c0kEOaY8H2nvI+gqmG2xmcSHEAuNwJaOUmw09ibzpOhKDaOxhKFDBPDmAj3z70eF0p2rJ0DhNCJCRCYA4ShThKExA4TQiwmhAA4TQiwmhAA4TQiwmhAA4TQiwmhAAoShEhKEADhNCLlTQgAUJQiFqbKgAcJoRIShAA8qYtRIShAwWVNlRYTEIACWpsqNCaEhgtr13MEsAzcXAxHIrz/aVMuuQBJgwZMHfO/j4rttr1QJBM69kBwJ8R81ym06zXCGBreQ4wb8/9V5nkStnRjRkYDHuYX0wTlIEDflDsxv/AE0V+njHBp7Ul8TG+1/BZ2JpS7MBEtEjTd8dUTDGGnTK3z8/Nczm+CulDVH5XZgWyCLEWI33Oh0Mq63GN1yx4zBWLVHajLEgmJ0IvqpnEmC6b6C/nHDeprY0zaFTO5sgZbAAn1uX92bE/wBV2HRvJLLezYwQBAyuGZkDut4rz3B1WvdTJMEEB/CJs7S0W8l2WzMcOxoC+SYNpe6d/AQPJdmBqLsjNWjrKGHaycoAlEhcqdtQTmJAa4jQxYmIEXHaHkVobE2qahy3EaA6kcTwnguyOeF0RcHybUJQiQlCuYBwmhFhNlTAHCUIkJoQAOEoRISypioFCUImVKEAChKEXKmyosKBEJZUTKllQFAiE2VFypZUBQLKmyouVNlSAFlUYRoTQgYGE0IxaolqBnnFfb7ic7ZBG5wEgi4uOy4brx86WN2oKvac0SdS2AZ36aFZbmEyROs2vbj7PamvI1+v6cV4Lk2dtJFunUdAOn0Yme9TbZtre8lAY6e6dNOO9HzAiNQRbjMmO9TGV8Q8l1+Btp5KpiXXjhu5omJkOnvj64qf2V7xnAJHwACokBVZIutWgxwY2oCZvFyIi8jgbe1ZzmRI8xv4q4+s6AB2ucQTujuiOadio0NnUjUdme8jgS4Akk3IP+i7fo9gXMe2ATYh823yPG/mF58w9oHSCJkhp13DwXpPR/HOdSaGAuH4jrG69gPCTyVvHSclfROeyOihKE9MmL6+PxUoXqnNRCEoRIShMAcJoRYTQgQPKlCJCUIAFCUIkJZUADhNCLCaEwBZUsqLlSyoAFlTZUWEoSAFlTZUWE0IGBLU2VGLU0IADlTZUaE0IA8Vr4JzSWxdok+QN0Jxgnj7Cui6QUSxzusd2n6gWsJOmpErn6hnQa9/1wXgy5o9CKbVkmOIaZvuGg00+uSGGAtsTI8Po/JGweHc+YElokyRAB+vYtBtFlhImA7TcAdTwS3BpGfjGFuRpb+IjiQYF+OmqYMJ9YnKTJE21nSw3xCvYhgDqZEHOyZMD1t9xZQiHWMm5DYsALySsqQ6RXq7MMS0zEbrb82k8kBrAD23R8YH9FZDjngEwL/3tL+B3qePpBzSddIuD5ELaluJoz+uuCBujyHxWpsvbVeiAGulv4STAE/IqnsjZz6tmCbHwIk/BW8VsSo0G0GSORge8kO9iok1ujDrg7rov0k60hrsoJ+6Bc8dNV2IXhGzsS9tQZCQ8ExvBPMcLL2no/tH7Rh2VSMpI7Q1h2+DvC7fGyNqmRyx7RfhKFOE8LqsjQOEoU4ShOwohCaESEoTsAcJQiQlCLEDhLKpwllRYA8qaEWEoRYAoTQiwmhFgDhNCLCaEWAKExCLCaErGCypoRYTZUWFHitXEF7nVKjiXHeboFOoTOUm8NnlAk+CJiRAOs/D69ybZgDYJEiRa14uQZ3fMLwY7noykbHQ3ZzXEue+JqGm0y2A8NDrg65hYHiOaTdktbiOqc/K4wBMjMc0WPGxtz5KhgySHtbxqvtqMpZlPeDJC18ZTOM6kusTAc8CREySeECfFXTWnclTbM7boy1GBgjJTaO4hvusqdLFzJtLhBmANPaNVuvqYcY2syo4llUFodEZSYIm++Inms7anR6o006bYdYNDhp+J7jxABPhCjjx3BM0206ZRxVaAXAmYAbugcUfCYU1GUqbBLn9p1iIJcQO8RB8VWxLcrYcOMayACWie+J8ZXpvQPZFMYalX1c5rhIn1ZgCDvsqYsbboJypWcZsvFVdn1wTGVxylpFjzuRFzrO/vXX7Zw1PE4V72AtqNIeWDXOGloA75HK3JZ/T3AExTaJLjYncNCeervMcEL0dbTDj9mfckS03kt0IJ5H60XTHZ6OiL3VmL0a2MH4mHAFpmCOIIBI4i+vML1fAYJtJmVqlhtn06d2MA8FZhXx41AxKVkYShTDU5aq6jFEIShTyp8qNQUDhLKiZU+VGoKBZUsqJCUJ6goFlSyo4YllS1oekAWpsqOWKJanrFpBQmhEypZUagoFCWVEhNCLCgcJiEQhNCLAHCaEQhNlSsdHhG1BBA489NOQhGwjS1zQbxJdOgbME8j2iO8BD2o397HA7uVyVPGYlobDBBdmknWDIgrxlwdrW5Z2DGWtDS4uMMFxJGYgTumQe4K/sOoW0qhta1r77mdDPHkVibJxrmlzWWkTImbdk6bo9yuYR5DKxFhLAPDPPwSm/jRqEfkZlWrmqEmYkzGscV3nREivSOHJIJa9jKljH4hyMR3ifDiNm4cv6w2GVpJJmGgm5t5eNl0XQN5lxFnC9wYNyASdBe1lbHsYnuyv032W+hWBiGvgNJ17AsAN0NLJ5r0b0e0//AC2hO8OPhndC5H0tV8z8KNOxUJHCSwfBd30Qo5MBhm/2LD4uGY+9VhtkZh/0FPphhiKFSq318mRhiYzHtEDjEwV550DEYukPxF+UWkQ47t2/6uvXtpYXraZpzE7xu5jmuY2R0ObRxDKrCQ1hMAmdSDJO/f5rUk3JMyjq4ShFhNlV9RPSQhJEypixGoNJEKYhRhOEWBNqXgmAUpSs1RAhMAiKQCNQaQSUIjgmASsVA4TFFIUSE9aXIaWwcJZVNMpy8nGuzawzfRAsUS1TLh9FDdWH+n9VF+dFcIovGb5YsiYtQ3Vh3/XJRNQ9yhLzcj42KrxoLkMAol31I+azcbiyyHTYesNbHeOc+9OMY3XNqueXkzfMiqxRXR51tPou+lTp1nSXuP7wDRs5iMp5AeKp9I9lBmFp1m3c6q6mTxAEh3KY9q19pbUqPpudnJlxhjg6GwSYm4EcyuYxONqFt6hOvZO7mRxKu5LpHOrM3ZFTLWE6XBHGbe9bGG7OGJ3ue8nlAEBNgaJexzySBZoAiecyPcnrPIphpa60zYyTw8bbtyzN2qNRdMtdGcK52FxHBxYNwJjgTrMkRzJ3I/RPENoV3GoHhpBAyC4MTvgEbteKyXYwloDGkNFrNIHjCbrXzmgkzpJgcBDt5W1NmWjR9IO0mV8TTNOcraIFxEOzPJ9mXRexYCnlpU2/hYweTQF4HRfVLrv13PcbGZJy/Wq9A9H+26znik9znsIdeAQ1wAN3Oh0Ry3jmVWE/kZktj0NPKo/7RYdjSA5jy4gSHs7I3m5EeCsUsQxzczXAjiCCPMKymm6E4NK2HBTyg0awcMzTYoOJ2jRpkNqVWNJ0DnAHyKdmaLkpIGHxLHjMxzXDi0gj2Isp2Kh5STSnndBJ4AEn2JOSXIKN8EoShVcXjGUhNRzKY41ajKfscZ9ix63TDBAhv2lriTAFGm+pc/ncGsHfmhTlniiixtnRhIujWB4rhMd6Q6bTlZhcQ90gAVajKTZJgepmjz8Vs4DatZtZhxbtn4encupNqtr4h1jDWklw1iSN0wpPPJ8I2sUVydC2oCYbLj+UEqVRjh6wDP8A3HNb5AlYNR1LE1HuZicfVaCP93w/WU2sBFg5wyCDB9YrR2fgMNTBf9nNM/2lRmcn8zqZIP6ipSyTff8ABRRiui07KNare5gLvbp7UJkuktEgd0++J8VDF03OEU30mDdDZP6s0+0IVLZwFnPzCdJgXHBut513c7rnlZVUNTxZcCW03mCQbbwR8we5SJqH7j/0njH156K1SpOaIbkHISBJMm3j56ojW1Py7958Nyx8vRrYzMr/AOG/xa7ny5fVlF7XgFxY4AAmS1/Cdw4K7jca6kA9zZZIlzZOWd5EaTZYuP2s4gmgGuzgBzGkuMnNDmti8QBcX9qLfoW3RonDQ4NfVyCSHEU6hym0C4Gs68lR6Quo0RZ9V5g/ccBnsW3MWid6tbOw+Nq0nNqYepLxDnOcKbRwhrnSPAIT/R7iKsddiGgRlgZnGNwJgSea0k30Zk67MHanSikKZbSwdTOWFrnPgta/2yBpoDobLmaHTDqmimcjstgWvc1oHBuUQRz4k8F61/sBTf8A8evVq66xv4TMI7fR9gAINMnmSPgFRR9ok5R9nk2C6LbWdSDeodl9ZoMNuZk3ANweKm/0c7Sfc0wDA1LDeO1K93akU1uFr0eMYXoLtKnRfTLGOzEGc4ER/i1WU30fbRqOJ6tg0IJLeMjtZp38V71VhoLiYAuSdwCGIIkXBuPgt6Ji1RPCcR6N9pSJa08Mr2wCTwkwNfYmHo22g20CXSbPbrb8y9zc6EI1PqUaJ+hXE8Jd6N9ozBYL3sWQY4QbarpeiPRrF4N7i6lUcHQIb1RtedXTrl8ua9Pz8lDD1w9uYcXD9JIPuQ3OO4/i+jwjHYZhq1CWAEvcSIE3cdVd2TjGNomkxzGHOSSJDp0IduIgDUKrWfL3HiSfMofRXZ7qoqvAaQKpBzE23zAFxoYkaJKVbs7M8filR121dvVqWHaWQS+zXWzR+JrdDu81wOKqOc7M/M5xnU3J7zfifBa22KFVkkse3L94N7BaOGseazRVBALwSCNxggSAbHxWnLUzhcUix0a2y3CVxWJeWkEOptIBMwAXAjdMju716jtfEYwBpw4w5BInrBULotplcBx3FeR0yGva+k8lrXte1rhAMQ7KYN7iDxldptbpCX1N1L5mBDQQ4bxDzA7j3KimkmYJ7Q6YbTNSoygyg0NeWZmUSe0IntVHERO+PAaLl6e1cdiQDWxlTtEtDet6sO7WWAxsA3tou+9HlenUpVc1LOesJnXM55YAL2MAOceAXO9HNl0i7CVurrVA0NNTJTc4A9e9xFhubGnvU2ysd+DkNs7Mp0xUBdNVtyIdM2Nz3LawvRx/qiTroJOq3umuxnZsZim4aq2g8NLXublyjK1pJBM3M+a9C2n0wbhew+jRouyyGVsVSpvI3EMYHE6JbPazW63PM8T0UrfZaznU3lrKZc0uYYEETBItbMfBAr7Dq0sPh3w5vWU2OphhAcZY0uNrxprzXfbQ6X/a8NiqNKphXOGHqvy03VqhyiA45ixo0dHeQuTfhK9SthwXU2v+x0CwvljBTDSGgkSS6N9pSkqWxbBvK2UNlbdfgs739Y8vAa0Pc7KCLm2/uWJtjpOazw6pnfrlaS3K3uaLD2960ulmHr06TS+pRLXPaCKbnE/iE5hpLQud23jKlcNzFvZmIaG+tEzGugU1G18i04ybbRsYXHPcwP8AVbxIAHDWF0uKx7KFBtSpcdkHKATJHBedU8bVdlokwwvaCwNAHriw3+1GpYaQ8EXDZ7jmaPioy8e3uzOp0dceleHMxmEcWgfFZ1fGnEWo1ntE3It7lxmGE06hO7L7103QGjmnk4j2Apy8dQTafBOOW2kz1P0edEaXUmrXdVqkugZ6jyIAvYHnpyXoOFwrKYy02NaODQB7lU2Dh+rw9Nv5ZPe65960FaC23Oacm39hy5R6wKNaYsq+V3H2z7gFuyZhbV6Zto4v7IKJc7LmzZwBGUEWjnHgsnH9N8YHxRwjHtgdovIuRJHtC5f0k0nHanZcWuNBhloJntFu48YWNTqPp9g1KbiIk1S7MTlGg3N4LWxqcaW32/0e8BOmCSnHlG2B2o54pOyCXWEGNCRmN7aSsfB7XZTY4VnwGQcwa7KGmBuGgJ1036LR23XyUv8Ah1KkkAtpSHAQTJIvFvasGpjwQR9mxQEyTNcaDWRct7ThHIdk2jssmlZgUdq7Re6kaJz5qVV7mVQGAtqYh7KL5gEZGZXRvaDvKq09s4lrMI+piHuzMbnYwNbVe91YgODXUy2oMsAtBaWgTvXRO2nF24XFkg2/4lzmaBJNjIc47xDDxCE3GZngHC4ltwM2eplF2CYHJ53fcKyUv7HTBZ+znxhs3J58JcVoBZOHdGz839i4/wApKlnfAsfJ4s02CpbC29Ww7XtptYQ55cS4OmbDUOFrK2dFk7KrFsODcxzTlyh0/wCEgz5FYStHd5LqjrD0wc4A0Qx5AOcFtRgGkR2zP3uHtVKrt81jFTC0CTJBOexF7mZAidN8IFCm9xksGSNXYTDAh24R1Uz/AKyi4qk0ucZAdItlY0C4kZQ3hO4JNRRyKTkUesp3ik2m7MZioXi1zBeZ4p20i+tSY1w7bqTN8RYT3TP1K0cPRYGAB9MuglxcykSTvBDxpAGnAoONqPa+k8NytZDgaVNoFncWAgHswPFF2zOk6boNha4wvWUa9Cl11QtAqPeKhLMhIpgAiIeATrHegbB6dY2jhKdDD02w5rjTAGd4F7xHbiCe4JdE8aw0ew6lFF1VzWlpz9oMu079L8ICythV8hpYkuZbNTYwAS0P6y7GkiGxmEk2zcSEayn4P+Am0elG0qtB1PEVnGk+WlpZTaDADoEAG1tOC1PTjVA2jTB/gMj9T1Do3UqVXVRSoda31hSLKfZLiGi7gHMMMn14IIVzpd0bxGLxPX1merTAb+9ZmJbJDQ1mY3O8iE03J0JxUUmYHo6ILsYR/wBFiG+M01udJWNc7BsdvweFnjoQn2VQODa5zMKKZeIe41agFyCYLnj8I0WHt3GGpXdmIIaxgADs4DfWDcxJmMyc4SiivitSmZ/SrBtpsp5TOZ978NPesYhW9qtAYIH3m/FVpUkqVHdFNN2WqeVop1SJyOa7vDakkLXquGWqYu5kfzsdH8qx64/3c9x96s7ZeRQLhr2fePmmt6FkSqX6f9MLZzf3dfk0H2rs/RRhw9xbFzUaPMXXD7PxDml0R2omQDz3r0T0Q4mq7aLWF8MyuJDW0xmIEgE5Zix0jRayJ01+h50Y7X+p7w0QpKKcIRAaohEolbRZON+0l37osDQNCJcTG46C/GdExJHAekjCn7aCIc59KmWl7QWsYw1OsZYSQ4lhnXW8Lz3a1NzapD3MzQD6o0i0AaWXovpUbTFfCvquLf3bwMoc7tBzD93vK4DFYCm4g0xUcIEkjLLt8A7klL5V/H8lmrS3PowOUXOBET5GCvI243Hj/n1v+875og2vtD+NW/XKwpR9nR9M/Z6kQ38Z/Wfmhvpj8Tv1leZHbe0tBVqx/hPvQn7a2mf+ZUj+7T+SepfmF9O/semnDj8bv1lRdh2/id+srzL9s7V/G/8ATS+SX7U2sfvv/TR+SWpfmD6d/Y9LOHb+J36yqO3MtPA1mtgBtF4AncGkBefftjaU9quxvJzqAPlCztq9KMQGuo1cWx2cEFjQ0yDaJayB5o2fYLDT5Rg1DY9xVXYmxHVabavWZQSRABmBbWfgrNdpyOPI+5UNmbQa2kGFrjEzHeea2m62N+TTas2KnRoG3WmN4LBfIyIVp2xWBgYyo5oGs5XSNY0ELHbjWn7lTwhGYQdKNU+H9ENN8nMq6LlfYVIuBFZzRvBLTI4AiIsrH7PpjKG13BrdAXAkdx3eSoswzzph3+Lo/wDyjMwFX/p/N/8AVL+40vsXKGz6DHNc17RlDhc3OYy4kgi6als3DB7XZ29gZWgOIIEyb5u8eKhS2fU30mfrIPxVxmz/AMkf4x/lWG17KKy/gMeyk17KddtMPlxIBe7MGw0EkzG7xKz6XSnIcoxhc8EjJ1NUmItdwyn3QjswDfvD+Yn4BOdi4d3rMB7wD7StQz6FRmeFzdnNbX26a2dtdz3hh/diGNg5dSIned6BgKcNBmc1Nh7pgwurHR3C/gb4CPcqeO2IWkmkJbAGXeDN9US8hT2LeNh/DnbOd2r6g/vNVWF0D9h1agylpAnXs25wSFqt6DYYxOLq+DAEtUWuS88umXFnKPYTQIGpDoRNtf8Ap3dzPe1dhj+j2HwtJoZWNUHNJewGP7x3KGJ6L4lvbLWNbaCSIHC0W7ktaQ3KM09+VRwPRm7n9w+K7r0TODcZQm0mqJ/w9pEpbAr8aXt/yo+D6PVqbmuZUZTLTILG5SDyIghKWeLZmEKx6G+n+57SHc1JeWtxm06fq4kvH5iHf/cfFEb0u2jT9djHd9L4sIWo5IPs5X4c+mj01zQbFIUxwXmzPSNXHrUKR7i5vxVun6SD97C+Iqn4tVPj7MPxMq6/c7bFbNo1CDUpMeRMZmh0TrE6aBA/YWF/gs8BC5lvpIo/ew9Udzmn3wp/+I+G/g1//j/zJ7ezH02X0cdicY9ziWim0HdkkD2haGB2qGsDX06bnXl2WJ4WMxZc42u/8I/V/REFV/5R5lcWqR26Ymjtmo6s5ppvFIARla03M6kgjko7LL6QIdU6wk6umw4alUw9/Fv6T804zfiHgEa5C0RLW2WGuwM6w04dmllibEQfNVcLgMjcvXPdc3JE38FMN/Mf5fknFP8AM7zRrl7Hoj6M/DdGcMxxcGuJM3L3b9dFdZsygDPVMJ4uAcfMqZoA/ef+pCfggd/nf3pOTfLBRS4RbGUCzQguqs/CPJVRs4/iae9p+aKzAN3geAIRshu2GbVZuHsKgcSyY+B+SIzCtG4/qPzRQxFoVMEx4OnuKKITp7IsKYoSyp45KUIAhlTgKUJBqAHaeSICEPKkAkAdruQ8lLMq4lSa4rNDsMPr63qWNLqtPqnudlkGAdCNI+SDnKkKvJG64B0+S1sEU6DXh4NQuu0ui0CwtpfePgo9GOte94xbmtAAykFgzOJvcbhwgaoAqpxUW1N9qzDh6Y3SPb9LC1+pguGVpzSAL7huPmtbYTDiqArsgNcSAHG5ymJtzWU4jeEahi3sEMcWjgLDyReN8xCp9MNtevSoPFOtkzESAW57XEm3IqphqWHrktYxjzEkMBBjjA8EDaWGZXdnqy50AZpIMDQWPNE2ExuFe6pTElzcpDiSImbeQT+HTaC8iDVNgs/hPH6viq37Io8XfqHyW+ekbi0gsFwRIPHeuHOx6v8AFb/23f5lr49TNLJk7RAKQQgpArBoKFIIQcpByQwgKmHIQcpAoAKHJw5DlSCACBycOUE6ACZk4KGFIJAEBTgocqSAJpwhynCACQlChKcFAEoT3UZSlIKJJeCaU8oASVkpSlADyE881GUpQBOeaUqEpWSAnKUqBTFAE8yWZDKbxRQGECpBOkqmRwVMFJJIZIFOCnSQBIFOCkkkBIJwUkkDHBUg5JJAEgU8pJJASDkpTpIAQKlKSSQCTpkkAOkkkgBJJJIAcFKUkkAKUpSSQBMhvE+X9VAxxSSSAYpkkkAf/9k=";

const SignIn = () => {
  const navigate = useNavigate();
  const [errorsMsg, setErrorMsg] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const usernameRef = useRef(null);
  const passwordRef = useRef(null);

  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };

  const handleTogglePasswordVisibility = () => setShowPassword((prev) => !prev);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(
        `${REACT_EXPRESS}/loginWithOutOtp`,
        formData,
      );
      const { token, validity, userFirstLogin, isAdmin } = response.data.data;

      if (validity === "Found" && token) {
        sessionStorage.setItem("isAdmin", isAdmin == null ? "" : String(isAdmin));
        sessionStorage.setItem("authToken", JSON.stringify(token));
        window.dispatchEvent(new Event("tokenUpdated"));

        // if (userFirstLogin) {
        //   navigate("/changepwd", { state: { email: formData.username } });
        // } else {
          navigate("/home");
        // }
      } else {
        setErrorMsg(validity || "Invalid Credentials");
        setOpen(true);
      }
    } catch (error) {
      setErrorMsg(error.response?.data?.message || "Something went wrong");
      setOpen(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        height: "100%",
        width: "100%",
        overflow: "hidden",
      }}
    >
      {/* LEFT SIDE: Your Provided Image */}
      <Box
        sx={{
          flex: 2,
          display: { xs: "none", md: "block" },
          position: "relative",
          backgroundImage: `url(${welcomeimage})`,
          backgroundSize: "cover",
          // backgroundPosition: "center",
          padding: 0,
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* Deep Purple/Blue Overlay for that professional look */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(46, 30, 84, 0.45)",
            mixBlendMode: "multiply",
          }}
        />
      </Box>

      {/* RIGHT SIDE: Login Form */}
      <Box
        sx={{
          flex: 1,
          backgroundColor: "white",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          px: { xs: 4, lg: 8 },
        }}
      >
        <Box sx={{ maxWidth: "400px", width: "100%" }}>
          {/* Logo */}
          <Box sx={{ display: "flex", justifyContent: "left", mb: 2 }}>
            <img
              src={logo}
              alt="Logo"
              style={{ width: "130px", height: "auto" }}
            />
          </Box>

          <Typography
            variant="h5"
            sx={{ fontWeight: 500, color: "#333", mb: 1.5, fontSize: "1.6rem" }}
          >
            Customer Self-Service Portal
          </Typography>

          <Typography
            variant="body2"
            sx={{ color: "#555", mb: 4, lineHeight: 1.5 }}
          >
            Review your portfolio. Buy new products.
          </Typography>

          <Box component="form" onSubmit={handleSubmit} noValidate>
            <FormControl fullWidth sx={{ mb: 3 }}>
              <FormLabel
                htmlFor="username"
                sx={{
                  fontSize: "0.9rem",
                  color: "#8bc34a",
                  fontWeight: "600",
                  mb: 1,
                }}
              >
                Email Address:
              </FormLabel>
              <TextField
                inputRef={usernameRef}
                id="username"
                name="username"
                variant="filled"
                placeholder="Email Address"
                hiddenLabel
                fullWidth
                size="small"
                value={formData.username}
                onChange={handleChange}
                sx={{
                  "& .MuiFilledInput-root": {
                    backgroundColor: "#f7f7f7",
                    borderRadius: "4px",
                    "&:before, &:after": { display: "none" }, // Removes the underline
                  },
                }}
              />
            </FormControl>

            <FormControl fullWidth sx={{ mb: 4 }}>
              <FormLabel
                htmlFor="password"
                sx={{
                  fontSize: "0.9rem",
                  color: "#8bc34a",
                  fontWeight: "600",
                  mb: 1,
                }}
              >
                Password:
              </FormLabel>
              <TextField
                inputRef={passwordRef}
                name="password"
                placeholder="Password"
                type={showPassword ? "text" : "password"}
                variant="filled"
                fullWidth
                size="small"
                value={formData.password}
                onChange={handleChange}
                sx={{
                  "& .MuiFilledInput-root": {
                    backgroundColor: "#f7f7f7",
                    borderRadius: "4px",
                    "&:before, &:after": { display: "none" },
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleTogglePasswordVisibility}
                        edge="end"
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>

            <Button
              type="submit"
              fullWidth
              variant="contained"
              disabled={loading}
              sx={{
                py: 1.6,
                backgroundColor: "#2e4d44",
                borderRadius: "4px",
                boxShadow: "none",
                "&:hover": { backgroundColor: "#1e332d", boxShadow: "none" },
                textTransform: "none",
                fontSize: "1rem",
              }}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Sign in"
              )}
            </Button>

            <Box
              sx={{
                mt: 3,
                display: "flex",
                flexDirection: "column",
                gap: 1.5,
                alignItems: "center",
              }}
            >
              <Link
                component="button"
                type="button"
                onClick={() => navigate("/resetpwd")}
                variant="body2"
                sx={{
                  color: "#666",
                  textDecoration: "none",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                Forgot your password?
              </Link>
              <Link
                component="button"
                type="button"
                onClick={() => navigate("/signup")}
                variant="body2"
                sx={{
                  color: "#8bc34a",
                  fontWeight: "bold",
                  textDecoration: "none",
                }}
              >
                Don't Have Account, Sign Up
              </Link>
            </Box>
          </Box>
        </Box>
      </Box>

      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        message={errorsMsg}
        action={
          <IconButton size="small" color="inherit" onClick={handleClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />
    </Box>
  );
};

export default SignIn;
